module.exports = __webpack_public_path__ + "right_handle.png";